/* eslint-disable arrow-body-style */
import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { responsive, responsiveContainer } from "../../utils/responsive";
import { spacingVariants } from "../../utils/vanilla/spacingVariants";

export const gridStyle = style({
  //
});

export const gridTitleStyle = style({
  flexGrow: 1,
});

export const gridContainerStyle = recipe({
  base: {
    display: "grid",
    width: "100%",
  },
  variants: {
    variant: {
      none: {},
      default: {
        gap: theme.spacings.s,
        ...responsive({
          base: {
            gridTemplateColumns: "repeat(4, 1fr)",
          },
          s: {
            gridTemplateColumns: "repeat(12, 1fr)",
          },
        }),
      },
      comparision: {
        ...responsive({
          base: { gap: theme.spacings.m },
          s: { gap: theme.spacings.l },
        }),
      },
      oneColumn: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.m,
      },
      twoColumn: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.s,
        ...responsiveContainer({
          500: {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
        }),
      },
      /**
       * Always two columns, regardless of container width. Use for fixed
       * pairs (e.g. social login buttons) that must never collapse to a
       * single column — unlike `twoColumn`, which is container-responsive.
       */
      twoColumnFixed: {
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: theme.spacings.s,
      },
      threeColumn: {
        gap: theme.spacings.s,
        gridTemplateColumns: "repeat(2, 1fr)",
        ...responsiveContainer({
          600: {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
        }),
      },
      fourColumn: {
        gap: theme.spacings.s,
        gridTemplateColumns: "repeat(2, 1fr)",
        ...responsiveContainer({
          600: {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
          700: {
            gridTemplateColumns: "repeat(4, 1fr)",
          },
        }),
      },
      twoColumnMarketing: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.m,
        ...responsiveContainer({
          800: {
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: theme.spacings.l,
          },
        }),
      },
      threeColumnMarketing: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.m,
        ...responsiveContainer({
          600: {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
          800: {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
        }),
      },
      threeThirds: {
        gridTemplateColumns: "repeat(1, 1fr)",
        gap: theme.spacings.m,
        ...responsiveContainer({
          600: {
            gridTemplateColumns: "repeat(3, 1fr)",
          },
        }),
      },
      /**
       * @deprecated use twoColumn instead
       */
      verticalCard: {
        gap: theme.spacings.s,
        gridTemplateColumns: "repeat(1, 1fr)",
        "@container": {
          "layoutContent (min-width: 400px)": {
            gridTemplateColumns: "repeat(2, 1fr)",
          },
        },
      },
      /**
       * @deprecated use threeColumn instead
       */
      card: {
        gap: theme.spacings.s,
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        selectors: {
          /**
           * When the child count is even but not a multiple of 3, force
           * 2 columns so rows stay balanced (e.g. 2×2 instead of 3+1).
           * Uses max() to fall back to 1 column on narrow containers
           * where the 240px minimum can't fit twice.
           */
          "&:has(> :nth-child(2n):last-child):not(:has(> :nth-child(3n):last-child))":
            {
              gridTemplateColumns: `repeat(auto-fit, minmax(max(240px, calc(50% - ${theme.spacings.s})), 1fr))`,
            },
        },
        ...responsiveContainer({
          s: {
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 0.5fr))",
          },
        }),
      },
    },
    gap: {
      ...spacingVariants("gap", true),
    },
  },
  defaultVariants: {
    variant: "default",
  },
});
